module.exports = __webpack_public_path__ + "img/avatar7.a7f9d8f0.png";